<template>
  <div class="header header1">
    <!-- TOP BAR -->
    <div class="topbar">
      <div class="row">
        <a href="https://app.horabela.com.br/login">Login</a>
      </div>
    </div>
    <!-- END OF TOP BAR -->

    <!-- LOGO & NAVIGATION -->
    <div class="header-navigation">
      <div class="row">
        <div class="col-sm-12">
          <div class="logonav">
            <div class="row no-gutter">
              <div class="col-sm-3">
                <div class="logo">
                  <router-link to="/home">
                    <img src="/main-site/images/logo-horabela.png" alt />
                  </router-link>
                </div>
              </div>
              <div class="col-sm-9">
                <nav id="desktop-menu">
                  <ul class="sf-menu" id="navigation">
                    <li>
                      <a href="https://app.horabela.com.br/login">Login</a>
                    </li>
                    <li class="current">
                      <router-link to="/home">Home</router-link>
                    </li>
                    <li>
                      <router-link to="/planos">Planos</router-link>
                    </li>
                    <li>
                      <router-link to="/quemsomos">Sobre Nós</router-link>
                    </li>
                    <li>
                      <router-link to="/contato">Contato</router-link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END OF LOGO & NAVIGATION -->
  </div>
</template>

<script>
export default {
  mounted() {
    this.injectStylesheets();
    this.initializeScripts();
  },
  beforeDestroy() {
    this.removeStylesheets();
  },
  methods: {
    injectStylesheets() {
      const cssFiles = [
        '/main-site/css/bootstrap.min.css',
        '/main-site/css/bootstrap-theme.min.css',
        '/main-site/css/block_grid_bootstrap.css',
        '/main-site/css/font-awesome.min.css',
        '/main-site/css/typicons.min.css',
        '/main-site/css/odometer-theme-default.css',
        '/main-site/css/slider-pro.min.css',
        '/main-site/css/animate-custom.css',
        '/main-site/css/owl.carousel.css',
        '/main-site/css/owl.theme.default.min.css',
        '/main-site/css/slicknav.min.css',
        '/main-site/css/style.css'
      ];

      cssFiles.forEach(file => {
        if (!document.querySelector(`link[href="${file}"]`)) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = file;
          link.dataset.mainSiteStyle = 'true';
          document.head.appendChild(link);
        }
      });
    },
    removeStylesheets() {
      document.querySelectorAll('link[data-main-site-style]').forEach(link => link.remove());
    },
    initializeScripts() {
      const loadScript = (src, cb = () => {}) => {
        if (document.querySelector(`script[src="${src}"]`)) { cb(); return; }
        const s = document.createElement('script');
        s.src = src;
        s.onload = cb;
        s.dataset.mainSiteScript = 'true';
        document.body.appendChild(s);
      };

      loadScript('/main-site/js/jquery.min.js', () => {
        loadScript('/main-site/js/bootstrap.min.js', () => {
          loadScript('/main-site/js/jquery.hoverIntent.js', () => {
            loadScript('/main-site/js/superfish.min.js', () => {
              loadScript('/main-site/js/jquery.sliderPro.min.js', () => {
                loadScript('/main-site/js/owl.carousel.min.js', () => {
                  loadScript('/main-site/js/odometer.min.js', () => {
                    loadScript('/main-site/js/waypoints.min.js', () => {
                      loadScript('/main-site/js/jquery.slicknav.min.js', () => {
                        loadScript('/main-site/js/wow.min.js', () => {
                          loadScript('/main-site/js/retina.min.js', () => {
                            loadScript('/main-site/js/custom.js');
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    }
  }
}
</script>


